import { Component, OnInit }  from '@angular/core';
import { TranslateService }   from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { ActivationStatusModel } from './typings/my-workshop.activation-status';
import { CodeTypeModel }         from '../core/models/code-type';
import { ConfirmService }        from '../messages/confirm/confirm.service';
import { MessagesService }       from '../messages/messages.service';
import { MyWorkshopService }     from './my-workshop.service';
import { MyWorkshopStatusModel } from './typings/my-workshop.status';

@Component({
  selector   : 'wor-my-workshop-settings',
  template: require('./my-workshop.settings.component.html')
})
export class MyWorkshopSettingsComponent implements OnInit {
  @BlockUI('myWorkshopSettingsBlock') block : NgBlockUI;

  status : ActivationStatusModel;
  type   : string;
  types  : Array<CodeTypeModel> = [];
  url    : string;


  constructor (
    private confirmService    : ConfirmService,
    private messagesService   : MessagesService,
    private myWorkshopService : MyWorkshopService,
    private translateService  : TranslateService,
  ) {}

  ngOnInit () : void {
    this.block.start();

    this.myWorkshopService.getStatus()
    .then(( status : MyWorkshopStatusModel ) => {
      this.status = status.status;
      this.url    = status.workshop_url;

      return this.myWorkshopService.getWorkshopTypes();
    })
    .then(( types : Array<CodeTypeModel> ) => {
      this.type  = types[0]?.code;
      this.types = types;
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  activate () : void {
    this.confirmService.custom({
      message: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.MY_WORKSHOP.ACTIVATE_CONFIRMATION'),
      buttons: {
        confirm: {
          class: 'success',
          title: this.translateService.instant('GENERAL_SPACE.BUTTON.ACTIVATE')
        }
      }
    })
    .then(() => {
      this.block.start();

      return this.myWorkshopService.activate(this.type);
    })
    .then(( response ) => {
      this.status      = 'publish';
      this.url = response.workshop_url;

      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.MY_WORKSHOP.MY_WORKSHOP')
      }), 'success');
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  isStatus ( status : ActivationStatusModel ) : boolean {
    return this.status === status;
  }
}
